import i18n from "@/i18n";

const EcConnectionStatus = {
    0: i18n.t("ec_connection.status_inactive"),
    1: i18n.t("ec_connection.status_active")
};

const EcConnectionType = {
    1: i18n.t("ec_connection.type_meg"),
    2: i18n.t("ec_connection.type_ks"),
    3: i18n.t("ec_connection.type_pc"),
    4: i18n.t("ec_connection.type_jut")
};

export { EcConnectionStatus, EcConnectionType };
